<template>
  <div class="p" v-if="subjectList.length>0">
    <div class="overview-head">
      <div class="overview-head__num"></div>
      <div class="overview-head__title">共性错题</div>
    </div>
    <!-- 搜索条件 -->
    <SearchCriteria
      :gradeId="gradeId"
      :classId="classId"
      :masterClassId="masterClassId"
      @subjectChange="subjectChange"
      @courseChange="courseChange"
      @timeChange="timeChange" />
    <!-- 错题展示 -->
    <Correlation
      ref="correlate"
      :gradeId="gradeId"
      :classId="classId"
      :courseId="courseId"
      :startDate="startDate"
      :endDate="endDate"
      :knowledgeWrongList = "knowledgeWrongList"
      class="p-correlation"/>
    <el-pagination
      background
      v-if="knowledgeWrongList.length > 0"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
      :page-size="pagination.pageSize"
      :page-sizes="[10, 20, 50]"
      :current-page="pagination.currentPage"
      @size-change="sizeChange"
      @current-change="currentChange">
      </el-pagination>
  </div>
  <div v-else>
      <empty content="暂无数据~" />
    </div>
</template>

<script>
import Correlation from '@/views/pt/class-analysis/components/correlation.vue';
import SearchCriteria from './search-criteria.vue';
import { getCommonWrong, getSubjectCourseList } from '@/api/pt';
import { unlocking } from '@/utils/access-control';
import Empty from '@/views/pt/components/empty.vue';
// import dayjs from 'dayjs';

export default {
  name: 'CommonError',
  components: {
    SearchCriteria,
    Correlation,
    Empty,
  },
  props: {
    gradeId: {
      require: true,
    },
    classId: {
      require: true,
    },
    masterClassId: {
      require: true,
    },
  },
  data() {
    return {
      knowledgeWrongList: [],
      dateRange: [Date.now() - 6 * 24 * 3600 * 1000, Date.now()],
      subjectId: '',
      startDate: '',
      endDate: '',
      subjectList: [],
      courseId: 0,
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  mounted() {
    this.getSubjectCourseList();
  },
  watch: {
    classId() {
      this.getCommonWrong();
    },
  },
  methods: {
    sizeChange(v) { // 每页条数
      this.pagination.currentPage = 1;
      this.pagination.pageSize = v;
      this.getCommonWrong(); // 切换每页条数时重新请求数据
    },
    currentChange(v) { // 当前页
      this.pagination.currentPage = v;
      this.getCommonWrong(); // 切换页码时重新请求数据
    },
    timeChange(val) {
      this.startDate = val.startDate;
      this.endDate = val.endDate;
      this.getCommonWrong();
    },
    getSubjectCourseList() { // 学科列表和课程列表请求
      getSubjectCourseList({
        class_id: this.classId,
        subject_id: '',
        grade_id: this.gradeId,
        school_master_class_id: this.masterClassId,
        is_charge: unlocking('Master_Sale_Manager') ? 1 : 0,
        is_filter: 0,
      }).then((res) => {
        this.subjectList = res.data.subject_list;
      }).catch((err) => {
        console.error('获取学科列表失败:', err);
      });
    },
    courseChange(val) {
      this.courseId = val;
      this.getCommonWrong();
    },
    subjectChange(val) {
      this.courseId = 0;
      this.subjectId = val;
      this.pagination.currentPage = 1;
      this.getCommonWrong();
    },
    getCommonWrong() {
      getCommonWrong({
        sort: '',
        descSort: '',
        pageSize: this.pagination.pageSize,
        page: this.pagination.currentPage,
        grade_id: this.gradeId,
        class_id: this.classId,
        school_master_class_id: this.masterClassId,
        subject_id: this.subjectId || 0,
        course_id: this.courseId || 0,
        start_time: this.startDate.replace(/-/g, ''),
        end_time: this.endDate.replace(/-/g, ''),
      }).then((res) => {
        if (res.code === 200) {
          this.pagination.total = res.data.total || 0;
          this.knowledgeWrongList = res.data.list || res.data || [];
          // 过滤掉没有题目的数据
          this.knowledgeWrongList = this.knowledgeWrongList.filter((item) => item.question_title_uuid === '');
        }
      }).catch((err) => {
        console.error('获取共性错题失败:', err);
        this.knowledgeWrongList = [];
        this.pagination.total = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .p {
    padding:45px 0 0 19px;
    .overview-head{
      display: flex;
      align-items: center;
      &__num{
        font-size: 22px;

        font-weight: bold;
        color: rgba(0, 0, 0, 0.8);
        margin-right: 14px;
        background:url('~@/views/pt/images/class_bg.png');
        background-size:cover;
        width:38px;
        height:29px;
        line-height: 29px;
        text-align: center;
      }
      &__title{
        position: relative;
        left: -40px;
        font-size: 17px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.8);
      }
    }
    &-correlation {
        margin-top: 60px;
      }
      & /deep/ .el-pagination {
      margin-top: 20px;
      display: flex;
      // position: absolute;
      margin-left: 30px;
      width: calc(100% - 64px);
      bottom: 30px;
      left: 32px;
      & .btn-prev {
        margin-left: auto;
      }
      // & .el-select{
      //   left: -55px;
      // }
    }
  }
</style>
